import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    markers = [];

    connect() {

        const zoom = this.element.dataset.zoom ?? 14;
        let center = this.element.dataset.center;
        let locations = this.element.dataset.locations;
        locations = locations ? JSON.parse(locations) : {};

        if (center) {
            center = center.split(',');
            center = [center[0], center[1]];
        }

        if (locations.length > 0) {
            this.element.removeAttribute('data-locations');
            center = [locations[0][0], locations[0][1]];
        }

        import('leaflet').then(L => {
            const map = L.map(this.element, {
                center: center,
                zoom: zoom,
                zoomSnap: false,
                scrollWheelZoom: false,
            });

            L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                attribution: '',
                id: 'demovilius/cluv3yuk9004y01qzdaxnfn03',
                tileSize: 512,
                zoomOffset: -1,
                accessToken: 'pk.eyJ1IjoiZGVtb3ZpbGl1cyIsImEiOiJjbHV2M3d0dXIwaGdjMmpyeDNrZ2YxemtnIn0.MC6jQ3rhQIgcWMi_q7pmfA',
            }).addTo(map);

            if (locations.length > 0) {
                const popupOptions = {
                    closeOnClick: false,
                    autoClose: false,
                    closeButton: false,
                }

                locations.forEach((info) => {
                    const popup = new L.popup(popupOptions)
                        .setLatLng(new L.latLng(info[0], info[1]))
                        .setContent(info[2]).openOn(map);
                    this.markers.push(popup);
                });

                if (locations.length > 1) {
                    // try to fit markers in map view
                    const bounds = new L.featureGroup(this.markers).getBounds();
                    map.fitBounds(bounds, { padding: [50, 100] });
                }
            }
        });
    }
}